import { render, staticRenderFns } from "./refundGoodsInfo.vue?vue&type=template&id=078d19df&scoped=true"
import script from "./refundGoodsInfo.vue?vue&type=script&lang=js"
export * from "./refundGoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./refundGoodsInfo.vue?vue&type=style&index=0&id=078d19df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078d19df",
  null
  
)

export default component.exports